import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ id, title, price, stock, image, deliveryType, customUrl, productType }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const inStock = productType === 'catalog' || deliveryType === 'explicit_api' || (Array.isArray(stock) && stock.length > 0);
  const productUrl = customUrl ? `/${customUrl}` : `/product/${id}`;
  
  // Normaliser le chemin de l'image
  const normalizedImagePath = image && !image.startsWith('/') ? `/${image}` : image;

  return (
    <div className="glass-card rounded-lg overflow-hidden transform hover:scale-[1.02] transition-all duration-300 will-change-transform">
      <div className="relative w-full h-48">
        {!imageLoaded && (
          <div className="absolute inset-0 bg-gray-800 animate-pulse"></div>
        )}
        <img
          src={normalizedImagePath}
          alt={title}
          className={`w-full h-full object-cover transition-opacity duration-300 ${
            imageLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          onLoad={() => setImageLoaded(true)}
          loading="lazy"
        />
      </div>
      <div className="p-4">
        <h3 className="text-lg font-semibold text-white">{title}</h3>
        <div className="flex justify-between items-center">
          <span className="price-text font-bold">{productType === 'catalog' ? `€${price}` : `$${price}`}</span>
          <span className={`text-sm ${inStock ? 'text-green-500' : 'text-red-500'}`}>
            {productType === 'catalog' ? (
              <span className="flex items-center">
                On stock <span className="ml-1 text-lg">∞</span>
              </span>
            ) : (
              deliveryType === 'explicit_api' ? 'Available' : inStock ? `${stock.length} in Stock` : 'Out of Stock'
            )}
          </span>
        </div>
        {inStock ? (
          <Link
            to={productUrl}
            className="neon-button mt-4 w-full block text-center text-white font-bold py-2 px-4 rounded transition duration-200"
          >
            Purchase
          </Link>
        ) : (
          <button
            disabled
            className="mt-4 w-full block text-center bg-gray-600 text-gray-400 font-bold py-2 px-4 rounded cursor-not-allowed"
          >
            Currently Unavailable
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductCard; 